// Librairies.
import React   from 'react';
import classes from './Spinner.module.css';

// Spinner
const Spinner = () => <div className={classes.loader}>Chargement...</div>;

export default Spinner;